/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, OnChanges} from '@angular/core';
import * as _ from 'lodash';
import {SiteGroupResource} from '../../../components/api/resources/resource/site-group.resource';

@Component({
  standalone: false,
  selector: 'adn-targeting-site-group-target-summary',
  template: '<strong *ngIf="negated">NOT:&nbsp;</strong>{{siteGroups}}'
})
export class SiteGroupSummaryComponent implements OnChanges {
  @Input() targets: any;

  siteGroups = '';
  negated = false;
  private cache: Record<string, string> = {};

  constructor(@Inject(SiteGroupResource) private readonly SiteGroup: any) {
  }

  ngOnChanges(): void {
    const target = this.targets || {};
    this.negated = target.negated;
    const hasNameAlready = !!_.get(target, 'siteGroups[0].name');
    if (hasNameAlready) {
      this.siteGroups = _.map(target.siteGroups, 'name').join(', ');
      return;
    }
    const siteGroupIds = _.get(target, 'siteGroups[0].id') ? _.map(target.siteGroups, 'id') : target.siteGroups;
    const queryIds = _.without(siteGroupIds, ...Object.keys(this.cache));
    if (queryIds.length === 0) {
      this.siteGroups = _.map(siteGroupIds, (id) => this.cache[id]).join(', ');
      return;
    }
    this.SiteGroup.query(queryIds, (page) => {
      _.forEach(page.results, (s) => {
        this.cache[s.id] = s.name;
      });
      this.siteGroups = _.map(siteGroupIds, (id) => this.cache[id]).join(', ');
    });
  }
}
